import { render, staticRenderFns } from "./notrip.vue?vue&type=template&id=77830c3c&scoped=true&"
import script from "./notrip.vue?vue&type=script&lang=js&"
export * from "./notrip.vue?vue&type=script&lang=js&"
import style0 from "./notrip.vue?vue&type=style&index=0&id=77830c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77830c3c",
  null
  
)

export default component.exports